import isEmpty from "../helpers/isEmpty";
import {isValidAbsoluteURL} from "jsdom/lib/jsdom/living/helpers/form-controls";

export const processAssignmentLink = (url) => {
    if (isEmpty(url))
        return linkStatus.empty;

    if (isValidAbsoluteURL(url))
        return linkStatus.absolute;
    else
        return linkStatus.transfer;
}

export const linkStatus = {
    empty: 'empty',
    absolute: 'absolute',
    transfer: 'transfer'
}

